import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { CaretRight } from "@app/sharedComponents/Icons/Icons";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { ScrollView } from "react-native";
import CollateralIcon from "../../assets/Icons/CollateralIcon";
import PrepayLoan from "../../assets/Icons/PrepayLoan";
import MutualFundIcon from "../../assets/Icons/MutualFundIcon";
import DiscardLoan from "../../assets/Icons/DiscardLoan";
import PoorFeedback from "../../assets/Icons/PoorFeedback";
import OtherFeedbackIcon from "../../assets/Icons/OtherFeedbackIcon";
import ROUTE from "@app/navigationApp/routes";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import { useState } from "react";
import CloseReasonInfo from "./components/CloseReasonInfo";
import { endpoints } from "@app/api/apis";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { REPAYMENT_COLLECTION_TYPE, trackEvent } from "@app/utils";
import PoorExperience from "./components/PoorExperience";
import { updateForeCloseReason } from "@app/store/slices/commonSlice";
import { calPayableAmount } from "@app/screens/ConfirmPay/components/helper";
import useFetchForeclosureDetails from "@app/hooks/useFetchForeclosureDetails";
import PageLoader from "@app/sharedComponents/PageLoader/PageLoader";

const reasons =[
    {
        id:1,
        icon:<CollateralIcon/>,
        title:"I want to release my collateral",
        info:'You can release your collateral while keeping your account active',
        subTitle:'Benefits of your account you should consider',
        data:[
            {
                heading:'Your assets, your ownership',
                subHeading:'Your assets remain in your name and continue to earn market returns.'
            },
            {
                heading:'Increase your credit limit in just 5 min',
                subHeading:'Add more collateral anytime to expand your borrowing capacity.'
            },
            {
                heading:'Easy collateral release',
                subHeading:'Free up your pledged assets partially or fully after clearing the outstanding balance.'
            },

        ],
        btn1:"Release collateral",
        btn2:"I still want to close account",
    },
    {
        id:2,
        icon:<PrepayLoan/>,
        title:"I want to prepay my loan",
        info:'Paying off the outstanding balance stops interest charges',
        subTitle:'Benefits of your account you should consider',
        data:[
            {
                heading:'Pay interest only on what you use',
                subHeading:'Interest is calculated daily on your utilized amount, unlike traditional loans.'
            },
            {
                heading:'Freedom of principal repayment',
                subHeading:'No fixed repayment schedule - pay principal at your convenience.'
            },
            {
                heading:'Strengthen your credit score',
                subHeading:'Maintaining your credit line account will help you  boost your credit score.'
            },

        ],
        btn1:"Clear dues",
        btn2:"I still want to close account",
    },
    {
        id:3,
        icon:<MutualFundIcon/>,
        title:"I want to sell my mutual funds",
        info:'You can release your collateral while keeping your account active',
        subTitle:'Benefits of your account you should consider',
        data:[
            {
                heading:'Pay only for what you use',
                subHeading:'Zero charges when not using the credit line - interest applies only on used amount.'
            },
            {
                heading:'Save on capital gains tax',
                subHeading:'Avoid STCG & LTCG by keeping investments while accessing funds at lower borrowing costs.'
            },
            {
                heading:'Maximize investment returns',
                subHeading:'Let your investments grow in the market while having ready access to funds.'
            },

        ],
        btn1:"Release collateral",
        btn2:"I still want to close account",
    },
    {
        id:4,
        icon:<DiscardLoan/>,
        title:"I don’t need a loan anymore",
        info:'Our loan account acts differently compared to traditional loans',
        subTitle:'Benefits of your account you should consider',
        data:[
            {
                heading:'Instant access to cash',
                subHeading:'Get the funds you need, when you need them, for any emergency or opportunity.'
            },
            {
                heading:'Control over repayment',
                subHeading:'Pay back what you borrow on a schedule that fits your needs.'
            },
            {
                heading:'Easy collateral management',
                subHeading:'Quickly add or remove collateral to adjust your credit limit.'
            },

        ],
        btn1:"Keep account active",
        btn2:"I still want to close account",
    },
    {
        id:5,
        icon:<PoorFeedback/>,
        title:"I had a poor experience",
        subTitle:"Help us improve"
    },
    {
        id:6,
        icon:<OtherFeedbackIcon/>,
        title:"Other",
        subTitle:"Other"

    }
]

const SelectCloseReason = ({navigation})=>{
    const dispatch = useAppDispatch();
    const [isBottomSheetVisible,setIsBottomSheetVisible] = useState(false);
    const [userFeedback, setUserFeedback] = useState('')
    const [poorFeedback, setPoorFeedback] = useState('')
    const [bottomSheetType,setBottomSheetType] = useState({});
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const {fetchForeclosureDetailsLoading,foreClosureData} = useFetchForeclosureDetails();
    const {lendingPartnerId} = userDetails?.linkedCredits[0];

    const openBottomSheet = (type)=>{
        trackEvent("SELECT_CLOSE_REASON", { selected_reason: type.title });
        setBottomSheetType(type);
        setIsBottomSheetVisible(true);
    }

    const closeBottomSheet = ()=>{
        setIsBottomSheetVisible(false);
    }

    const fetchForeclosureDetails = (id:number,paymentType:REPAYMENT_COLLECTION_TYPE, remark: string | null = null) => {
        const foreClosureReason ={
            customerReason:reasons[id-1]?.title,
            customerReasonRemark:remark || null
        }
        dispatch(updateForeCloseReason(foreClosureReason as any))
        const isFromForeclosure = true;
        if(foreClosureData?.netPayable || (id===2 && paymentType===REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT)){
            if(paymentType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT){
                const isFromClearDues = true;
                const payableAmount = calPayableAmount(foreClosureData?.netPayable,true,lendingPartnerId,foreClosureData,isFromClearDues);
                navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount:payableAmount,paymentType,isFromForeclosure,isFromClearDues})
            } else{
                const isFromClearDues = false;
                const payableAmount = calPayableAmount(foreClosureData?.netPayable,true,lendingPartnerId,foreClosureData,isFromClearDues);
                navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount:payableAmount,paymentType,isFromForeclosure,isFromClearDues})
            }
        }else{
            navigation.navigate(ROUTE.CONFIRM_LOAN_DETAILS,{paymentType,isFromForeclosure})
        }
    }

    const obj ={
        1:{
            btn1Fn:()=>{
                closeBottomSheet();
                setTimeout(()=>{
                    navigation.navigate(ROUTE.PLEADGE_MF)
                },700)
            },
            btn2Fn:()=>{
                console.log('btn2')
                closeBottomSheet();
                fetchForeclosureDetails(1,REPAYMENT_COLLECTION_TYPE.FORECLOSURE)
            }
        },
        2:{
            btn1Fn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(2,REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT)
            },
            btn2Fn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(2,REPAYMENT_COLLECTION_TYPE.FORECLOSURE)
            }
        },
        3:{
            btn1Fn:()=>{
                closeBottomSheet();
                setTimeout(()=>{
                    navigation.navigate(ROUTE.PLEADGE_MF)
                },700)
            },
            btn2Fn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(3,REPAYMENT_COLLECTION_TYPE.FORECLOSURE)
            }
        },
        4:{
            btn1Fn:()=>{
                closeBottomSheet();
                setTimeout(()=>{
                    navigation.navigate(ROUTE.HOME)
                },700)
            },
            btn2Fn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(4,REPAYMENT_COLLECTION_TYPE.FORECLOSURE)
            }
        },
        5:{
            btnFn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(5,REPAYMENT_COLLECTION_TYPE.FORECLOSURE,poorFeedback)
            }
        },
        6:{
            btnFn:()=>{
                closeBottomSheet();
                fetchForeclosureDetails(6,REPAYMENT_COLLECTION_TYPE.FORECLOSURE,userFeedback)
            }
        },
    }
    return(
        fetchForeclosureDetailsLoading ? <PageLoader/> :
        <>
        <PageHeaders pageName="SelectCloseReason" label="Select reason" navigation={navigation}/>
        <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-primary"],padding:16}}>
            <ThemedText variant="h3s" color="text-primary" mb="md">Why do you want to close your loan?</ThemedText>
            {
                reasons.map((reason,index)=>(
                    <ThemedPressable onPress={()=>openBottomSheet(reason)} key={reason.id} p="md" mb="md" borderWidth={1} borderColor="border-primary" borderRadius="sm" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                            {reason.icon}
                            <ThemedText variant="b3r" color="text-primary" ml="sm">{reason.title}</ThemedText>
                        </ThemedView>
                        <CaretRight/>
                    </ThemedPressable>
                ))
            }
        </ScrollView>
        <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={{backgroundColor:'#fefefe'}}>
            {bottomSheetType?.id < 5 && <CloseReasonInfo info={bottomSheetType} buttonFn={obj[bottomSheetType?.id]}/>}
            {bottomSheetType?.id == 5 && <PoorExperience id={bottomSheetType?.id} userFeedback={poorFeedback} setUserFeedback={setPoorFeedback} buttonFn={obj[bottomSheetType?.id]}/>}
            {bottomSheetType?.id == 6 && <PoorExperience id={bottomSheetType?.id} userFeedback={userFeedback} setUserFeedback={setUserFeedback} buttonFn={obj[bottomSheetType?.id]}/>}
        </BottomSheetContainer>
        </>
    )
}

export default SelectCloseReason;